module.exports = __webpack_public_path__ + "static/media/hh-logo.fb6bb779.svg";